<div class="fixed top-6 right-6 z-50">
  <div
    class="flex items-center gap-3 rounded-[8px] px-6 py-4 shadow-lg"
    [style.background-color]="getBackgroundColor()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      @if (type() == "success") {
        <polyline points="20 6 9 17 4 12"></polyline>
      }
      @if (type() == "error") {
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      }
      @if (type() == "info") {
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      }
    </svg>
    <p class="text-[14px] font-[500] text-white">{{ message() }}</p>
  </div>
</div>
